import type {
  BuildSessionReportInput,
  SessionReportTimeline,
} from "./types";

const sortByTimestamp = <T extends { timestamp: number }>(values: T[]): T[] =>
  values.slice().sort((left, right) => left.timestamp - right.timestamp);

export const deriveSessionReportTimeline = (
  input: BuildSessionReportInput
): SessionReportTimeline => {
  const phases = [
    {
      type: "created" as const,
      timestamp: input.auditState.createdAt,
    },
    ...input.auditState.phases,
  ];

  return {
    phases: sortByTimestamp(phases),
    incidents: sortByTimestamp(input.auditState.incidents),
    transcriptMilestones: sortByTimestamp(input.auditState.transcriptMilestones),
  };
};
